import { render, staticRenderFns } from "./quillText.vue?vue&type=template&id=fe342798&"
import script from "./quillText.vue?vue&type=script&lang=js&"
export * from "./quillText.vue?vue&type=script&lang=js&"
import style0 from "./quillText.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports